import React, {useState} from "react";
import styled from "styled-components";

import Input from "../components/common/Input";
import Button from "../components/common/Button";
import {ModalBody} from "../components/modal/Modal";
import {toast} from "react-toastify";
import axios from "axios";

const ChangePassword = ({handleCloseModal, modalDepth}) => {
    const [inputItems, setInputItems] = useState({

        currentPassword: "",
        newPassword: "",
        newPasswordCheck: "",

    });
    const [curPwChk, curPwChkVal] = useState(false);
    const [password, setPassword] = useState(false);
    const [passwordChk, setPasswordChk] = useState(false);
    // 비밀번호 눈아리
    let [typeChange1, setTypeChange1] = useState("password");
    let [typeChange2, setTypeChange2] = useState("password");
    let [typeChange3, setTypeChange3] = useState("password");

    const onChangeInput = (
        e,
        type
    ) => {
        if (type === "currentPassword") {
            setInputItems({
                ...inputItems,
                currentPassword: e.target.value,
            });
        } else if (type === "newPassword") {
            setInputItems({
                ...inputItems,
                newPassword: e.target.value,
            });
        } else if (type === "newPasswordCheck") {
            setInputItems({
                ...inputItems,
                newPasswordCheck: e.target.value,
            });
        }
    };
    const onClickSubmit = async (e) => {
        try {
            // e.preventDefault();
            if (inputItems.newPassword !== inputItems.newPasswordCheck) {
                toast('비밀번호가 일치하지 않습니다.');
                return
            }

            let moreData = {
                prevPassword: inputItems.currentPassword,
                newPassword: inputItems.newPasswordCheck
            };
            if (inputItems.currentPassword !== "" && inputItems.newPassword !== "" && inputItems.newPasswordCheck !== "") {
                await axios.patch("/users/updatePassword", moreData);
                handleCloseModal(modalDepth);
                toast('비밀번호 변경이 완료 되었습니다.');
            } else {
                // 현재 비밀번호 체크
                if (inputItems.currentPassword === '') {
                    toast('비밀번호를 입력해 주세요.');
                    return;
                }

                // 새 비밀번호 체크
                if (
                    (inputItems.newPassword === '' && inputItems.newPasswordCheck === '') ||
                    (inputItems.newPassword === '' && inputItems.newPasswordCheck !== '')
                ) {
                    toast('비밀번호를 입력해 주세요.');
                }

                // 새 비밀번호 확인 체크
                if (inputItems.newPasswordCheck === '' && inputItems.newPassword !== '') {
                    toast('비밀번호를 입력해 주세요.');
                }
            }
        } catch (e) {
            console.log(e.message);
        }
    };

    const logChkPress = async (e) => {
        if (e.key === "Enter") {
            await onClickSubmit();
        }
    }
    return (
        <ModalBody>
            <ChangePasswordPageModal>
                <ChangePasswordFormWrap>
                    <CustomInput
                        inputType={"text"}
                        id={"currentLogin"}
                        className={"input-hidden"}
                    />
                    <CustomInput
                        inputType={typeChange1}
                        id={"currentPassword"}
                        label={"현재 비밀번호"}
                        placeholder={"사용 중인 비밀번호를 입력해 주세요."}
                        onChange={(e) =>
                            onChangeInput(e, "currentPassword")
                        }
                        errorText={"현재 비밀번호가 일치하지 않습니다."}
                        className={curPwChk ? ' on' : ''}
                        typeChange={typeChange1}
                        setTypeChange={setTypeChange1}
                        onEyes={"on"}
                        onKeyDown={logChkPress}
                    />


                    <CustomInput
                        inputType={typeChange2}
                        id={"newPassword"}
                        label={"새 비밀번호"}
                        placeholder={"변경하실 비밀번호를 입력해 주세요."}
                        onChange={(e) =>
                            onChangeInput(e, "newPassword")
                        }
                        className={password ? ' on' : ''}
                        typeChange={typeChange2}
                        setTypeChange={setTypeChange2}
                        onEyes={"on"}
                        onKeyDown={logChkPress}
                    />

                    <CustomInput
                        inputType={typeChange3}
                        id={"newPasswordCheck"}
                        label={"새 비밀번호 확인"}
                        placeholder={"변경하실 비밀번호를 확인해 주세요."}
                        onChange={(e) =>
                            onChangeInput(e, "newPasswordCheck")
                        }
                        errorText={"비밀번호가 일치하지 않습니다."}
                        className={passwordChk ? ' on' : ''}
                        typeChange={typeChange3}
                        setTypeChange={setTypeChange3}
                        onEyes={"on"}
                        onKeyDown={logChkPress}
                    />

                    <ButtonWrap>
                        <Button
                            type={"fill"}
                            size={"xl"}
                            text={"변경"}
                            onClickFunc={onClickSubmit}
                        />
                    </ButtonWrap>
                </ChangePasswordFormWrap>
            </ChangePasswordPageModal>
        </ModalBody>

        // <ChangePasswordPageContainer>
        //     <ChangePasswordFormWrap>
        //         <h1 className="page-title">비밀번호 변경</h1>
        //         <CustomInput
        //             inputType={typeChange1}
        //             id={"currentPassword"}
        //             label={"현재 비밀번호"}
        //             placeholder={"사용 중인 비밀번호를 입력해 주세요."}
        //             onChange={(e) =>
        //                 onChangeInput(e, "currentPassword")
        //             }
        //             errorText={"현재 비밀번호가 일치하지 않습니다."}
        //             className={curPwChk ? ' on' : ''}
        //             typeChange={typeChange1}
        //             setTypeChange={setTypeChange1}
        //             onEyes={"on"}
        //         />
        //
        //         <CustomInput
        //             inputType={typeChange2}
        //             id={"newPassword"}
        //             label={"새 비밀번호"}
        //             placeholder={"변경하실 비밀번호를 입력해 주세요."}
        //             onChange={(e) =>
        //                 onChangeInput(e, "newPassword")
        //             }
        //             className={password ? ' on' : ''}
        //             typeChange={typeChange2}
        //             setTypeChange={setTypeChange2}
        //             onEyes={"on"}
        //         />
        //
        //         <CustomInput
        //             inputType={typeChange3}
        //             id={"newPasswordCheck"}
        //             label={"새 비밀번호 확인"}
        //             placeholder={"변경하실 비밀번호를 확인해 주세요."}
        //             onChange={(e) =>
        //                 onChangeInput(e, "newPasswordCheck")
        //             }
        //             errorText={"비밀번호가 일치하지 않습니다."}
        //             className={passwordChk ? ' on' : ''}
        //             typeChange={typeChange3}
        //             setTypeChange={setTypeChange3}
        //             onEyes={"on"}
        //         />
        //
        //         <ButtonWrap>
        //             <Button
        //                 type={"fill"}
        //                 size={"xl"}
        //                 text={"변경"}
        //                 onClickFunc={onClickSubmit}
        //             />
        //         </ButtonWrap>
        //     </ChangePasswordFormWrap>
        // </ChangePasswordPageContainer>
    );
};

const ButtonWrap = styled.div`
    margin-top: 48px;

    button {
        width: 100%;
    }
`;

const CustomInput = styled(Input)`
    margin-top: 16px;
    width: 100%;

    &:first-of-type {
        margin-top: 0;
    }
`;

const ChangePasswordFormWrap = styled.div`
    max-width: 440px;
    width: 100%;
    padding: 0 12px;

    .input-hidden {
        opacity: 0;
        position: absolute;
        left: 999%;
    }

    h1.page-title {
        color: var(--Gray-1000_-262626, #262626);
        text-align: center;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 36px;
        letter-spacing: -0.48px;
        margin-bottom: 56px;
    }
`;

const ChangePasswordPageModal = styled.div`
    background-color: #fff;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .warning-text {
        display: none;
    }

    .on {
        input {
            border-color: #E75434;
            box-shadow: 0px 0px 8px 0px rgba(231, 84, 52, 0.20);
        }

        .warning-text {
            display: block;
        }
    }
`;

export default ChangePassword;
